import React, { Component } from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import GroupList from './group_list';
import DataTypeList from './datatype_list';
import DataPipelineList from './pipelines_list';
import DataServicesList from './data_service_list';

// import DatatypeSourceList from '../sources/datatype_source_list';
// import DatatypeBalances from './datatype_balances';
import DatatypeFlags from './datatype_flags';
import TransactionActionsList from './transaction_actions_list';
import ReconcilerGroupList from './reconciler_group_list'
import ReconcilerGroupDetail from './reconciler_group_detail';
import ReconcilerEdit from './recon_edit';
import ReconcilerAddEdit from './recon_add_edit';
import GroupSourceList from './source_list';
import GroupLabels from './labels_list';
import ServiceExtractors from './service_extractors';
import DatatypeClassifiers from './datatype_classifiers';
import ServiceEnrichers from './service_enrichers';
import DatatypeEdit from './datatype_edit';
import DatatypeAdd from './datatype_add';
import GroupBatcherList from './group_batcher_list';
import BatcherRuleList from './batcher_rule_list';

class GroupSetting extends Component {
  render() {
    return (
    <Switch>
        {/* <Route path="/settings/groups/:user_id" component={UserDetail}/> */}


        <Route path="/settings/groups/datatype/:datatype_id/services/:service_id/enrichers" component={ServiceEnrichers}/>

        <Route path="/settings/groups/datatype/:datatype_id/services/:service_id/extractors" component={ServiceExtractors}/>
        <Route path="/settings/groups/datatype/:datatype_id/services" component={DataServicesList}/>
        <Route path="/settings/groups/datatype/:datatype_id/classifiers" component={DatatypeClassifiers}/>

        {/* <Route path="/settings/groups/datatype/:datatype_id/balances" component={DatatypeBalances}/> */}
        <Route path="/settings/groups/datatype/:datatype_id/labels"  component={DatatypeFlags}/>
        <Route path="/settings/groups/datatype/:datatype_id/actions"  component={TransactionActionsList}/>
        {/* <Route path="/settings/groups/datatype/:datatype_id/pipelines/create" component={DataPipelineCreate}/> */}
        {/* <Route path="/settings/groups/datatype/:datatype_id/pipelines/:pipeline_id" component={DataPipelineDetail}/> */}
        {/* <Route path="/settings/groups/datatype/:datatype_id/pipelines" component={DataPipelineList}/> */}
        {/* <Redirect from="/settings/groups/datatype/:datatype_id" to= "/settings/groups/:group_id/datatype"/> */}



        <Route path="/settings/groups/reconcilers/:group_id/rules/edit/:recon_id" component={ReconcilerEdit}/>
        <Route path="/settings/groups/reconcilers/:group_id/rules/add" component={ReconcilerAddEdit}/>

        <Route path="/settings/groups/batchers/:group_id/rules" component={BatcherRuleList}/>
        <Route path="/settings/groups/reconcilers/:group_id/rules" component={ReconcilerGroupDetail}/>

        <Route path="/settings/groups/:group_id/labels" component={GroupLabels}/>

        <Route path="/settings/groups/:group_id/datatype/:datatype_id/edit" component={DatatypeEdit}/>

        <Route path="/settings/groups/:group_id/datatype/add" component={DatatypeAdd}/>

        <Route path="/settings/groups/:group_id/datatype" component={DataTypeList}/>
        <Route path="/settings/groups/:group_id/reconcilers" component={ReconcilerGroupList}/>
        <Route path="/settings/groups/:group_id/batchers" component={GroupBatcherList}/>
        <Route path="/settings/groups/:group_id/source" component={GroupSourceList}/>

        



        <Redirect from="/settings/groups/:group_id" to={"/settings/groups"}/>
        <Route path="/settings/groups" component={GroupList}/>
        <Redirect from="*" to= "/settings/groups"/>
    </Switch>
    );
  }
}

export default GroupSetting;
